/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Success = 'Website.MyProfile.Subscription.Update.Success';
export const ConfirmButton = 'Website.MyProfile.Subscription.Update.ConfirmButton';
export const CancelButton = 'Website.MyProfile.Subscription.Update.CancelButton';
export const ConfirmWarning = 'Website.MyProfile.Subscription.Update.ConfirmWarning';
export const ConfirmQuestion = 'Website.MyProfile.Subscription.Update.ConfirmQuestion';
